import axios from '../../axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getSharedShortlist({}, token) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `core/sharedshortlists/${token}`,
          )
          .then((res) => resolve(res))
          .catch((error) => reject(error));
      });
    },
    postNewSharedShortlist({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('core/sharedshortlists/create', data)
          .then((res) => {
            // set currentContactId
            commit('contacts/setCurrenctContactId', res.data.contactId, { root: true });
            return resolve(res);
          })
          .catch((error) => reject(error));
      });
    },
    postNewSharedShortlistReferral({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('core/sharedshortlists/createreferral', data)
          .then((res) => {
            // set currentContactId
            commit('contacts/setCurrenctContactId', res.data.contactId, { root: true });
            return resolve(res);
          })
          .catch((error) => reject(error));
      });
    },

  },
};
